import { FC } from 'react';
import cn from 'classnames';
import { useTheme } from 'styled-components';

import { ThemePalette } from '../../types';

import { IconName } from './__generated__/icon.types';
import { SIZE_MAP } from './Icon.const';
import { IconSize } from './Icon.types';

import styles from './Icon.module.scss';
import './__generated__/icon.css';

export interface IconProps {
  name: IconName;
  className?: string;
  color?: keyof ThemePalette;
  size?: IconSize;
}

export const Icon: FC<IconProps> = ({
  name,
  color,
  className,
  size = 'md',
}) => {
  const { palette } = useTheme();

  return (
    <span
      style={{
        color: palette[color],
        fontSize: `${SIZE_MAP[size]}px`,
        lineHeight: `${SIZE_MAP[size]}px`,
      }}
      className={cn(`icon-${name}`, styles.root, className)}
    />
  );
};
